import React, { useLayoutEffect } from 'react';
import { motion } from 'framer-motion';
import { CombinedRoutes } from '../Common/Routes';
import { Route, Switch } from 'react-router';
import { useDispatch } from 'react-redux';
import { setPageTitle } from '../Store/Theme/actions';
import { withRouter } from 'react-router-dom';
import TopBar from '../Components/TopBar';
import Footer from '../Components/Footer';

const getUrlElem = (url) => {
    let urlSplit = url.split('/');
    let route = CombinedRoutes.filter(
        (c) => c.link !== null && c.link.split('/').length === urlSplit.length
    ).find((c) => c.link.split('/').every((i, j) => i[0] === ':' || i === urlSplit[j]));
    let urlParams = {};
    route?.link?.split('/').forEach((c, i) => {
        if (c[0] === ':') {
            urlParams[c.slice(1)] = urlSplit[i];
        }
    });
    let {
        component: Elem = null,
        title = null,
        ItemIcon: icon = null,
        saveData = false,
        multiWindow = true,
    } = route || {};
    return { Elem, title, icon, saveData, multiWindow, urlParams };
};

const HomeRoot = ({ history }) => {
    const dispatch = useDispatch();

    useLayoutEffect(() => {
        let path = getUrlElem(history.location.pathname);
        if (path) dispatch(setPageTitle(path.title));
    }, [history.location]); // eslint-disable-line

    return (
        <motion.div className="min-h-screen relative bg-pColor flex flex-col">
            <div className="sticky top-0 z-50">
                <TopBar />
            </div>

            <div className="flex-1 relative overflow-y-auto text-left px-1 py-1 text-tpColor">
                <Switch>
                    {CombinedRoutes.map((c) => (
                        <Route key={c.link} path={c.link} exact component={c.component} />
                    ))}
                </Switch>
                <Footer />
            </div>
        </motion.div>
    );
};

export default withRouter(HomeRoot);
